<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div style="display: flex; justify-content: space-between">
        <btn-tag
          href="/order_demands/new"
          :text="'添加' + $route.meta.name"
          :auth-id="31101"
          btn-class="btn-purple"
          icon-class="ion-plus-circled"
          module-name="orders"
        ></btn-tag>
        <button class="btn btn-default" @click="handleExportOrder">
          导出当前页需求
        </button>
      </div>
      <order-table :items="orders.list" class="m-t-20"></order-table>
      <pagination
        :records="orders.count"
        :page="filter.page"
        :per-page="filter.size"
        @paginate="loadData"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { orderList } from '@/service/getData'
import OrderTable from './table'
import { deepClone } from '@/utils'

export default {
  components: {
    OrderTable,
  },
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
      },
      orders: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1
      params.filter_user = true

      let res = await orderList(params)
      if (res.status != 0) return false
      this.orders = res.data
    },
    async loadData(page) {
      this.filter.page = page
      this.getData()
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          switch (j) {
            case 'is_drill_new':
              return v[j] == 2 ? '旧' : '新'
            case 'factory':
              return v[j].name
            case 'created_at':
              return this.$time(v[j]).format('YYYY-MM-DD')
            default:
              return v[j]
          }
        })
      )
    },
    formartOrderList(list) {
      let data = []
      let merges = []

      let rowIndex = 0
      list.map((item) => {
        rowIndex++
        if (item.drills.length == 0) {
          data.push(item)
        } else {
          item.drills.map((drill, index) => {
            if (index > 0) {
              rowIndex++
            }
            let item_drill = deepClone(item)
            item_drill.serial_number = drill.serial_number
            item_drill.drill_status_name =
              drill.status == 1 ? '已到达' : '未到达'
            item_drill.drill_receive_time =
              drill.status == 1 && drill.receive_time
                ? this.$time(item.receive_time).format('YYYY-MM-DD HH:mm')
                : ''
            data.push(item_drill)
          })

          if (item.drills.length > 1) {
            for (var i = 0; i < 20; i++) {
              merges.push({
                s: { r: rowIndex - item.drills.length + 1, c: i },
                e: { r: rowIndex, c: i },
              })
            }
          }
        }
      })
      return { list: data, merges: merges }
    },
    handleExportOrder() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          '订单号',
          '创建人',
          '创建时间',
          '进度',
          '状态',
          '钻头类型',
          '维修基地',
          '规格',
          '型号',
          '零件号',
          // '钻头数量',
          '使用区块',
          '成品个数',
          '半成品个数',
          '交货紧急程度',
          '销售类型',
          '喷嘴安装方式',
          '喷嘴',
          '包装',
          '备注',
          '外协厂家',
          '交货时间',
          '钻头序列号',
          '钻头状态',
          '钻头到达时间',
        ]
        const filterVal = [
          'order_number',
          'user_name',
          'created_at',
          'status_name',
          'option_status_name',
          'drill_type_name',
          'fix_base_name',
          'drill_size',
          'model_number',
          'component_number',
          // 'drill_number',
          'block_info',
          'cut_count_all',
          'cut_count_half',
          'urgent_level_info',
          'sale_type_info',
          'nozzle_install_info',
          'nozzle',
          'package_type_info',
          'remark',
          'factory',
          'deliver_time',
          'serial_number',
          'drill_status_name',
          'drill_receive_time',
        ]
        const d = this.formartOrderList(this.orders.list)
        const data = this.formatJson(filterVal, d.list)
        excel.export_json_to_excel({
          header: tHeader,
          // merges: d.merges,
          data,
          filename: '需求列表',
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        })
        this.downloadLoading = false
      })
    },
  },
}
</script>